<template>
  <div>
    <v-autocomplete
      v-bind:aria-invalid="hasViolations"
      append-icon=""
      attach
      background-color="white"
      clearable
      height="38px"
      hide-details
      item-text="name"
      item-value="id"
      outlined
      v-bind:items="options"
      v-bind:loading="loading"
      v-bind:value="value"
      v-on:input="$emit('input', $event)"
      v-on:update:search-input="$emit('search-input', $event)"
    >
      <template v-slot:append>
        <slot name="before-icon" />
      </template>
      <template v-slot:append-outer>
        <slot name="after-icon" />
      </template>
      <template v-slot:no-data>
        <slot name="no-data" />
      </template>
    </v-autocomplete>
    <div
      v-for="(error, index) in violations"
      v-bind:key="index"
      class="validate-error"
    >{{ error }}</div>
  </div>
</template>
<script>
/**
 * @description Поле поиска диагноза.
 * @type {Vue}
 */
export default {
  computed: {
    hasViolations() {
      return this.violations.length > 0;
    },
  },
  name: 'InputDiseaseSearch',
  props: {
    /**
     * @description Выбранная болезнь.
     * @type {(String|null)}
     */
    value: { default: () => null, type: String },
    /**
     * @description Загрузка результатов поиска.
     * @type {boolean}
     */
    loading: { required: true, type: Boolean },
    /**
     * @description Опции.
     * @type {any[]}
     */
    options: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Нарушение ограничений.
     * @type {string}
     */
    violations: { default: () => [], type: Array },
  },
};
</script>

<style lang="scss">
.validate-error {
  color: var(--warning-color);
  font-size: .8rem;
  font-weight: 400;
}
</style>
